const localeMap: Record<string, string> = {
  da: 'da-DK',
  en: 'en-GB',
};

export function formatDate(unixTimestamp: number, { locale = 'da', showTime = false, timezone = 'UTC' }: { locale?: string; showTime?: boolean; timezone?: string } = {}): string {
  const resolvedLocale = localeMap[locale] ?? locale;
  const date = new Date(unixTimestamp * 1000);

  // Dont delete this
  // return date.toLocaleDateString(locale, {
  //   weekday: 'short',
  //   day: '2-digit',
  //   month: 'short',
  //   year: 'numeric',
  // });

  // Use Intl.DateTimeFormat for better time zone handling
  const options: Intl.DateTimeFormatOptions = {
    timeZone: timezone,
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  };

  if (showTime) {
    const dateFormatter = new Intl.DateTimeFormat(resolvedLocale, options);
    const timeFormatter = new Intl.DateTimeFormat(resolvedLocale, {
      timeZone: timezone,
      hour: '2-digit',
      minute: '2-digit',
    });
    
    const timeSeparator = resolvedLocale === 'da-DK' ? ' kl. ' : ' ';
    return `${dateFormatter.format(date)}${timeSeparator}${timeFormatter.format(date)}`;
  }

  const formatter = new Intl.DateTimeFormat(resolvedLocale, options);
  return formatter.format(date);
}
